import { useIndexSelection } from "@/frontend/algolia/hooks/useIndexSelection";
import { Button } from "./ui/Button";
import { cn } from "../../utils/cn";

interface IndexOption {
    indexName: string;
    label: string;
}

export interface IndexSelectorProps {
    options: IndexOption[];
    onChange: (newIndex: string, prevIndex: string) => void;
    defaultSelectedIndex: string;
}

export default function IndexSelector({ options, onChange, defaultSelectedIndex }: IndexSelectorProps) {
    const { selectedIndex, selectionHandler, getHitsCount } = useIndexSelection(defaultSelectedIndex, onChange);

    return (
        <ul className="tw-w-full sm:tw-inline-flex sm:tw-border-t border tw-border-search-grey/50 sm:tw-mb-10">
            {options.map((option) => {
                const selected = selectedIndex === option.indexName;
                const hitsCount = getHitsCount(option.indexName);
                const isDisabled = !Boolean(hitsCount);

                return (
                    <li key={option.indexName}>
                        <Button
                            value={option.indexName}
                            onClick={() => !isDisabled && selectionHandler(option.indexName)}
                            className={cn(
                                "tw-text-search-grey hover:tw-text-black tw-text-xl sm:!tw-text-sm",
                                "first-of-type:tw-pl-0",
                                selected && "!tw-text-black",
                                isDisabled && "tw-cursor-not-allowed tw-opacity-50 tw-pointer-events-auto",
                            )}
                        >
                            {option.label} ({getHitsCount(option.indexName)})
                        </Button>
                    </li>
                );
            })}
        </ul>
    );
}
